/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_VisitInputs */

const en_directory_tool_visit = /** @type {(inputs: Directory_Tool_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit`)
};

const zh_directory_tool_visit = /** @type {(inputs: Directory_Tool_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问`)
};

/**
* | output |
* | --- |
* | "Visit" |
*
* @param {Directory_Tool_VisitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_visit = /** @type {((inputs?: Directory_Tool_VisitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_VisitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_visit(inputs)
	return zh_directory_tool_visit(inputs)
});
export { directory_tool_visit as "directory.tool.visit" }